(function (angular, app) {
   "use strict";
    
   // Heading
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.heading, HeadingDirective); 
      
   HeadingDirective.$inject = ["$window"
      , app.modules.common.services.functions];
   
   function HeadingDirective($window, ggFunctions) {
      return {
         restrict : "E"
         , templateUrl : "app/ui/directives/heading.html"
         , link: function (scope, element, attrs) {
          
            scope.Heading = {
               btnName: app.Branding.myAppName
            }


            var sizeWindow = function () {
               var windowSize = ggFunctions.fetchWindowSize();
               if (windowSize.width < 450) {
                  scope.Heading.btnName = app.Branding.myShortAppName;
               } else {
                  scope.Heading.btnName = app.Branding.myAppName;
               }
            }
            

            

            

            angular.element($window).bind('resize', function () {

               sizeWindow();
               scope.$digest();
               
            });

         }
      }
   }


}(angular, app));
